var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWinterStickMRDefault(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 74,
    height: 59,
    viewBox: "0 0 74 59",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.8574 9.83909C17.8574 9.83909 43.431 15.7758 59.4145 2.53235C59.4145 2.53235 63.0679 4.35903 63.0679 7.09906C63.0679 7.09906 42.061 19.4292 16.9441 14.4058L17.8574 9.83909Z",
    fill: "#EE4F66"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.3138 1.16211L19.6838 2.53212L5.98365 58.7027H5.07031L6.44033 42.7192C6.44033 42.7192 8.26701 26.7357 8.72368 26.279C9.18035 25.8223 12.377 10.7522 12.8337 10.7522C13.2904 10.7522 18.3138 1.16211 18.3138 1.16211Z",
    fill: "#66523B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0.960449 58.2461L11.0072 0.248901L18.314 1.16224L5.07049 58.7028L0.960449 58.2461Z",
    fill: "#6F5940"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.51403 8.87537H16.5376L15.3731 13.9399L8.55957 14.3783L9.51403 8.87537Z",
    fill: "#EE4F66"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M16.4873 8.92566L17.8573 9.839L16.9439 14.4057L15.3091 13.9445L16.4873 8.92566Z",
    fill: "#CB4358"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M8.02495 17.4563L14.4366 18.0134L13.2264 23.2652H7.02026L8.02495 17.4563Z",
    fill: "#CB4358"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M15.7979 18.4655L14.3959 18.0088L13.1948 23.2651L14.5374 23.6259L15.7979 18.4655Z",
    fill: "#C04053"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M32.4707 13.4924C32.4707 13.4924 54.391 20.7991 71.2878 10.2957C71.2878 10.2957 74.4845 13.949 73.5711 17.6024C73.5711 17.6024 43.4309 28.5625 20.1406 13.949L32.4707 13.4924Z",
    fill: "#EE4F66"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M22.2822 15.2095C45.2345 27.905 73.571 17.6024 73.571 17.6024C73.8084 16.6526 73.7628 15.7073 73.5755 14.8213C40.9601 24.722 29.3743 17.6207 25.7347 13.739L23.0403 13.8395L22.2822 15.2095Z",
    fill: "#E94D65"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M63.0679 7.09881C63.0679 6.23114 62.7025 5.4548 62.2002 4.80176C34.768 18.4197 20.5335 14.2686 17.2409 12.9259L16.9441 14.4056C42.061 19.4289 63.0679 7.09881 63.0679 7.09881Z",
    fill: "#DD4960"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWinterStickMRDefault);
export default __webpack_public_path__ + "static/media/winter_stick_m_r_default.ecc1835d15d45416e238e2f0389f4b40.svg";
export { ForwardRef as ReactComponent };